"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M9.5 4a1 1 0 011-1h3a1 1 0 011 1v6h3.265a.5.5 0 01.347.86l-5.747 5.56a.5.5 0 01-.694.002L5.894 10.86A.5.5 0 016.24 10H9.5V4zM20 19H4v2h16v-2z" }), "Downloads");
//# sourceMappingURL=Downloads.js.map